// removed by extract-text-webpack-plugin
module.exports = {"red":"#e40000","medium-grey":"#9f9f9f","grey":"#707070","white":"#ffffff","fastest":".15s","linear":"cubic-bezier(0, 0, 1, 1)","standard":"cubic-bezier(0.4, 0, 0.2, 1)","container":"_1MLHrcUm76SUSzr8Y0q9pB","header":"_1svIbIaZYNwGpz_GgNbIls","background":"_2mVPUOh6eHl3OHnQXJCFKP","filter":"_109jkYQ3US15qV3gTATtjs","active":"_2K2RZK1tAFtrLCqpA_Y74f","label":"_2VZD967rIUlZtQSVAmQJR8","filters":"_3DuGwE0BLnvXQJxl-K8m5e","full":"_3PqlFOVRdKJwZRPGt7ziDy","content":"_1QbAum3RYSBTRRY2zlOYoY","l":"_3T3f5Rfgt5Kcu9rpL-yL36","m":"_1Subs0pGRXO3gBgWKsu8bu","s":"_2UVKhyVBLNLVMy8rdsQaxu"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/elements/Tabs/FilterableTabs/FilterableTabs.css
// module id = 1158
// module chunks = 0